export default __webpack_public_path__ + "static/N0247-89221c799275e6f264553feea581de2c.png";